import { Component, Inject } from '@angular/core';
import { MD_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss']
})

export class ConfirmModalComponent {
    public question;

    constructor(@Inject(MD_DIALOG_DATA) question) {
        this.question = question;
    }
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/shared/confirm-modal/confirm-modal.component.ts